<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="tools">
	@if (authorizationService.canSee(grants.whatIf)) {
		<div class="tool-card">
			<div class="icon-title">
				<span class="icon-sustainability"></span>
			</div>

			<div class="content">
				<div class="info">
					<div class="text">
						<span class="title">What if</span>

						<span class="description">
							The "What-If" tool enables in-depth emission forecasting across various
							assets. It allows the creation and analysis of multiple customized
							scenarios by adjusting key parameters. This dynamic capability helps
							organizations simulate different operational conditions, providing a
							clearer understanding of potential emission outcomes and supporting
							strategic decision-making for sustainability initiatives.
						</span>
					</div>

					<globalictcc-button
						label="Read more"
						iconName="arrow-right"
						iconPosition="right"
						[textOnly]="true"
						(handleClick)="onToolReadMore('what-if')"
					/>
				</div>

				<globalictcc-button
					label="Select"
					(handleClick)="onToolSelected(paths.WHAT_IF)"
				/>
			</div>
		</div>
	}

	@if (authorizationService.canSee(grants.calculator)) {
		<div class="tool-card">
			<div class="icon-title">
				<span class="icon-meter"></span>
			</div>

			<div class="content">
				<div class="info">
					<div class="text">
						<span class="title">Calculator</span>

						<span class="description">
							The "Calculator" tool functions as a manual CO2 emissions calculator,
							allowing users to evaluate emissions for specific applications. By
							manually entering relevant data, users can generate customized emissions
							results. This feature is designed for flexible configuration, enabling
							assessments and specific calculations
						</span>
					</div>

					<globalictcc-button
						label="Read more"
						iconName="arrow-right"
						iconPosition="right"
						[textOnly]="true"
						(handleClick)="onToolReadMore('calculator')"
					/>
				</div>

				<globalictcc-button
					label="Select"
					(handleClick)="onToolSelected(paths.CALCULATOR)"
				/>
			</div>
		</div>
	}

	@if (authorizationService.canSee(grants.anomaliesDetection)) {
		<div class="tool-card">
			<div class="icon-title">
				<span class="icon-junction"></span>
			</div>

			<div class="content">
				<div class="info">
					<div class="text">
						<span class="title">Anomalies detection</span>

						<span class="description">
							The "Anomaly Detection" tool continuously monitors and identifies
							irregularities in application-related emissions in real time. By
							leveraging advanced monitoring capabilities, it swiftly detects
							deviations from expected patterns, enabling prompt interventions to
							mitigate potential inefficiencies. This proactive approach enhances
							operational efficiency and supports overall sustainability goals.
						</span>
					</div>

					<globalictcc-button
						label="Read more"
						iconName="arrow-right"
						iconPosition="right"
						[textOnly]="true"
						(handleClick)="onToolReadMore('anomalies-detection')"
					/>
				</div>

				<globalictcc-button
					label="Select"
					(handleClick)="onToolSelected(paths.ANOMALIES_DETECTION)"
				/>
			</div>
		</div>
	}
</div>

<router-outlet />

<!-- Dialogs content -->
<ng-template #whatIf>
	<span class="description">
		The "What-If" tool enables in-depth emission forecasting across various assets. It allows
		the creation and analysis of multiple customized scenarios by adjusting key parameters.
		<br />
		<br />
		This dynamic capability helps organizations simulate different operational conditions,
		providing a clearer understanding of potential emission outcomes and supporting strategic
		decision-making for sustainability initiatives.
	</span>
</ng-template>

<ng-template #calculator>
	<span class="description">
		The "Calculator" tool functions as a manual CO2 emissions calculator, allowing users to
		evaluate emissions for specific applications.
		<br />
		<br />
		By manually entering relevant data, users can generate customized emissions results. This
		feature is designed for flexible configuration, enabling assessments and specific
		calculations
	</span>
</ng-template>

<ng-template #anomaliesDetection>
	<span class="description">
		The "Anomaly Detection" tool continuously monitors and identifies irregularities in
		application-related emissions in real time.
		<br />
		<br />
		By leveraging advanced monitoring capabilities, it swiftly detects deviations from expected
		patterns, enabling prompt interventions to mitigate potential inefficiencies.
		<br />
		<br />
		This proactive approach enhances operational efficiency and supports overall sustainability
		goals.
	</span>
</ng-template>
